import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import iconCalendar from '../../images/icon-calendar.svg';
import { IDngrEvalList } from '../../interface/Interface';
import CustomDatePicker from '../ui/DatePicker';
import Select from '../ui/Select';
import * as securityHelper from "../../helper/SecurityHelper";


export default function DngrEvalList({ auth, goDetail }: any) {
  const [searchParams, setSearchParams] = useSearchParams();
  const dateParam = searchParams.get('date');
  const [datePopup, setDatePopup] = useState(false);
  const [date, setDate] = useState<Date>(fromDateParam(dateParam));
  const [dateView, setDateView] = useState('');
  const [selectEvntData, setSelectEvntData] = useState([]);
  const [selectEvntView, setSelectEvntView] = useState(searchParams.get('evntSeq') ?? '');
  const [selectCmpnyData, setSelectCmpnyData] = useState([]);
  const [selectCmpnyView, setSelectCmpnyView] = useState(searchParams.get('cmpnySeq') ?? '');
  const [selectEvntPopup, setSelectEvntPopup] = useState(false);
  const [selectCmpnyPopup, setSelectCmpnyPopup] = useState(false);
  const [listDatas, setListDatas] = useState<IDngrEvalList[]>([]);
  const prodRef = useRef<any>();
  const user = securityHelper.getLoginUser();
  const datePopupOpen = () => { setDatePopup(!datePopup); };
  const selectEvntHandler = (data: any) => {
    if (!data) {
      setSelectEvntView('');
    } else {
      setSelectEvntView(data.code);
    }
    setSelectCmpnyData([]);
    setSelectCmpnyView('');
    setSelectEvntPopup(false);
  };
  const selectCmpnyHandler = (data: any) => {
    if (!data) {
      setSelectCmpnyView('');
    }
    else {
      setSelectCmpnyView(data.code);
    }
    setSelectCmpnyPopup(false);
  };
  useEffect(() => {
    if (auth === 'KOX') {
      fn_retrieveEvntCodeList(setSelectEvntData);
    } else if (auth === 'COM') {
      fn_retrieveEvntCodeList(setSelectEvntData, user.companySeq);
    }
  }, []);

  useEffect(() => {
    if (auth === 'COM' && selectEvntData.length > 0) {
      let evntSeqArr: any = [];
      selectEvntData.map((data: any, idx) => {
        evntSeqArr.push(Number(data.code));
      })
      fn_retrieveCmpnyCdList({ evntSeqArr: evntSeqArr }, setSelectCmpnyData)
    }
  }, [selectEvntData])

  useEffect(() => {
    let year = date.getFullYear();
    let month: number = date.getMonth() + 1;
    let day = date.getDate();
    setDateView(`${year}. ${month >= 10 ? month : '0' + month}. ${day >= 10 ? day : '0' + day}`);
  }, [date]);

  useEffect(() => {
    if (auth === 'KOX') {
      fn_evntSelElmOnChange(selectEvntView, setSelectCmpnyData);
    }
  }, [selectEvntView])

  useEffect(() => {
    if (auth === 'SRV') {
      fn_retriveDngrEvalList({ cmpnySeq: user.companySeq, date: date, auth: auth }, setListDatas);
    } else if (auth === 'KOX') {
      fn_retriveDngrEvalList({ evntSeq: selectEvntView, cmpnySeq: selectCmpnyView, hstCmpnySeq: 0 }, setListDatas);
    } else if (auth === 'COM') {
      fn_retriveDngrEvalList({ evntSeq: selectEvntView, cmpnySeq: selectCmpnyView, hstCmpnySeq: user.companySeq }, setListDatas);
    }
  }, [selectEvntView, selectCmpnyView, date])

  useEffect(() => {
    const next = new URLSearchParams();
    if (auth === 'SRV') {
      next.set('date', toDateParam(date));
    } else {
      if (selectEvntView) next.set('evntSeq', selectEvntView);
      if (selectCmpnyView) next.set('cmpnySeq', selectCmpnyView);
    }
    setSearchParams(next, { replace: true });
  }, [selectEvntView, selectCmpnyView, date])

  return (
      <>
        <div className={auth === 'KOX' ? `h-125 md:h-[312px] flex flex-col items-center pt-7 md:pt-[17px]`
            : `h-76 md:h-[190px] flex flex-col items-center pt-7 md:pt-[17px]`}>
          {auth === 'SRV' &&
              <div ref={prodRef} onClick={datePopupOpen} className='hover:cursor-pointer w-[265px] sm:w-[318px] md:w-[750px] h-43 md:h-[107px] bg-[#2F2F35] flex justify-between items-center rounded-[5px] md:rounded-[12px]'>
                <p className='text-14 sm:text-15 md:text-37 font-preBold ml-15 sm:ml-20 md:ml-[50px]'>날짜</p>
                <p className='text-13 sm:text-15 md:text-37 font-preLight w-[210px] w-170 md:w-[425px]'>{dateView}</p>
                <img className='w-16 mr-16 md:w-[40px] md:mr-[40px]' src={iconCalendar} alt='calendar' />
              </div>}
          {auth === 'KOX' &&
              <div className='mb-14 md:mb-[35px]'>
                <Select selectHandler={selectEvntHandler} select={selectEvntView} selectPopup={selectEvntPopup} setSelectPopup={setSelectEvntPopup} selectData={selectEvntData} allData>행사명</Select>
              </div>}
          {auth !== 'SRV' &&
              <Select selectHandler={selectCmpnyHandler} select={selectCmpnyView} selectPopup={selectCmpnyPopup} setSelectPopup={setSelectCmpnyPopup} selectData={selectCmpnyData} auth={user.auth} selectEvntView={selectEvntView} dngrEvalList allData>업체명</Select>}
          {datePopup
              ? <div className='absolute top-57 md:top-[142px]'>
                <CustomDatePicker date={date} setDate={setDate} setDateView={setDateView} setDatePopup={setDatePopup} prodRef={prodRef} />
              </div>
              : null}
        </div>
        <div className={auth === 'KOX' ? `h-[calc(100%-177px)] md:h-[calc(100%-442px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center`
            : `h-[calc(100%-128px)] md:h-[calc(100%-320px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center`}>
          <div className='mb-20 pt-7 md:mb-[50px] md:pt-[17px]'>
            {listDatas.length === 0 ? <div className='mt-22 ml-10 md:mt-[55px] md:ml-[25px] text-13 sm:text-15 md:text-37 leading-18 md:leading-[45px] font-preBold'>조회된 데이터가 없습니다.</div> :
                listDatas.map((data, idx) =>
                    <div key={idx} onClick={() => goDetail(data.wrkDclrSeq)} className='w-[260px] sm:w-[308px] md:w-[735px]'>
                      <p className='mt-22 ml-10 text-13 md:mt-[55px] md:ml-[25px] sm:text-15 md:text-37 leading-18 md:leading-[45px] font-preBold truncate'>{data.evntNm}</p>
                      <p className='mt-8 ml-10 text-12 sm:text-14 md:text-[35px] leading-17 md:leading-[42px]'>{data.wrkInfo} {data.bthNos && `/ ${data.bthNos}`}</p>
                      <div className='border border-x-0 border-t-0 border-[#CACACA] w-full mt-28 md:mt-[70px]' />
                    </div>)}

          </div>
        </div>
      </>
  );
}

const toDateParam = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

const fromDateParam = (s: string | null) => {
  if (!s) return new Date();
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
};

const fn_retrieveEvntCodeList = async (setSelectEvntData: any, hstCmpnySeq?: number) => {
  let param = {};
  if (hstCmpnySeq) {
    param = { hstCmpnySeq: hstCmpnySeq };
  }

  const rtrnData = await axios.post('admin/api/dngrEval/retrieveEvntCodeList', param);
  setSelectEvntData(rtrnData.data);
}
const fn_retriveDngrEvalList = async (param: {}, setListDatas: any) => {
  const rtrnData = await axios.post('admin/api/dngrEval/retriveDngrEvalList', param)
  setListDatas(rtrnData.data);
}

const fn_evntSelElmOnChange = async (selectEvnt: any, setSelectCmpnyData: any) => {
  if (selectEvnt !== '') {
    await fn_retrieveCmpnyCdList({ evntSeq: selectEvnt }, setSelectCmpnyData);
  } else {
    setSelectCmpnyData([]);
  }
}

const fn_retrieveCmpnyCdList = async (param: any, setSelectCmpnyData: any) => {
  const rtrnData = await axios.post('admin/api/dngrEval/retrieveCmpnyCdList', param)
  setSelectCmpnyData(rtrnData.data)
}